import { forwardRef } from "react";

function SearchInput({
  value,
  onChange,
  placeholder,
  className = "",
  showShortcut = true,
  ...props
}, ref) {
  const hasValue = String(value || "").length > 0;
  const clearValue = () => {
    if (typeof onChange === "function") {
      onChange({
        target: { value: "" },
        currentTarget: { value: "" },
      });
    }
  };

  return (
    <div className={`search-input-shell ${className}`.trim()}>
      <span className="search-input-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="7" />
          <path d="m16.5 16.5 4 4" />
        </svg>
      </span>
      <input
        ref={ref}
        className="search-input"
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
      {hasValue ? (
        <button
          type="button"
          className="search-input-clear"
          aria-label="Clear search"
          onClick={clearValue}
        >
          x
        </button>
      ) : null}
      {showShortcut ? (
        <span className="search-input-shortcut" aria-hidden="true">
          Ctrl K
        </span>
      ) : null}
    </div>
  );
}

export default forwardRef(SearchInput);
